import * as Yup from "yup";

export const formData = {
  department: "",
  subDepartment: "",
  officer: "",
  premises: "",
  date: null,
  time: [],
  reason: "",
  memberCount: 0,
  documentFile: null,
  PurposeVisit: "",
  visitorData: [],
};

function validationSchema(customFields) {
  const generateFieldSchema = (field) => {
    let schema;

    switch (field.value_type) {
      case "string":
        schema = Yup.string();
        if (field.regex) {
          schema = schema.matches(
            new RegExp(field.regex),
            field.error_message || "Invalid format"
          );
        }
        break;

      case "boolean":
        schema = Yup.boolean();
        break;

      case "list":
        schema = Yup.array();
        break;

      default:
        schema = Yup.mixed(); // fallback
    }

    if (field.mandatory) {
      schema = schema.required(
        field.error_message || `${field.label} is required`
      );
    }

    return schema;
  };

  const dynamicVisitorSchemaShape = {};

  customFields.forEach((field) => {
    dynamicVisitorSchemaShape[field.name] = generateFieldSchema(field);
  });

  return Yup.object().shape({
    premises: Yup.string().required(),
    department: Yup.string().required("Department is required"),
    subDepartment: Yup.string().required("Sub Department is required"),
    PurposeVisit: Yup.string().required("Purpose of Visit is required"),

    officer: Yup.string().required("Officer is required"),
    date: Yup.date().required("Date is required"),
    time: Yup.array().required("Time is required"),
    reason: Yup.string().when("PurposeVisit", {
      is: (purpose) => purpose === "other",
      then: Yup.string().required("Reason is required"),
      otherwise: Yup.string("Official", "Personal"),
    }),
    organization: Yup.string(),
    designation: Yup.string(),
    documentFile: Yup.mixed().notRequired(),
    // ...dynamicVisitorSchemaShape,
  });
}

export default validationSchema;
